var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-table-settings", class: { "is-open": _vm.open } },
    [
      _c("div", { staticClass: "vks-table-settings-bar" }, [
        _c(
          "div",
          { staticClass: "vks-table-settings-before" },
          [_vm._t("before")],
          2
        ),
        _c(
          "button",
          {
            staticClass: "vks-table-settings-toggle",
            class: { "is-open": _vm.open },
            attrs: {
              type: "button",
              title: "Table settings",
              "aria-label": "Table settings",
              "aria-expanded": _vm.open ? "true" : "false",
            },
            on: {
              click: function ($event) {
                _vm.open = !_vm.open
              },
            },
          },
          [
            _c("b-icon", {
              attrs: { icon: "gear-fill", "aria-hidden": "true" },
            }),
          ],
          1
        ),
      ]),
      _vm.open
        ? _c("div", { staticClass: "vks-table-settings-panel" }, [
            _c(
              "section",
              {
                staticClass: "vks-table-settings-group",
                attrs: { "aria-labelledby": "vks-table-settings-table" },
              },
              [
                _c(
                  "h4",
                  {
                    staticClass: "vks-table-settings-group-title",
                    attrs: { id: "vks-table-settings-table" },
                  },
                  [_vm._v(" Table ")]
                ),
                _c("div", { staticClass: "vks-table-settings-group-body" }, [
                  _c("label", { staticClass: "vks-table-settings-per-page" }, [
                    _vm._v(" Rows per page "),
                    _c(
                      "select",
                      {
                        staticClass: "number-per-page",
                        domProps: { value: String(_vm.perPage) },
                        on: { change: _vm.onPerPageChange },
                      },
                      _vm._l(_vm.perPageOptions, function (option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: String(option.value) },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "vks-table-settings-columns" }, [
                    _c(
                      "div",
                      { staticClass: "vks-table-settings-columns-label" },
                      [_vm._v("Columns")]
                    ),
                    _c(
                      "div",
                      { staticClass: "vks-table-settings-columns-list" },
                      _vm._l(_vm.toggleableColumns, function (column) {
                        return _c(
                          "label",
                          {
                            key: column,
                            staticClass: "vks-table-settings-column-label",
                          },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.isColumnVisible(column),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onColumnToggle(column, $event)
                                },
                              },
                            }),
                            _c("span", [_vm._v(_vm._s(column))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "section",
              {
                staticClass: "vks-table-settings-group",
                attrs: { "aria-labelledby": "vks-table-settings-data" },
              },
              [
                _c(
                  "h4",
                  {
                    staticClass: "vks-table-settings-group-title",
                    attrs: { id: "vks-table-settings-data" },
                  },
                  [_vm._v(" Data ")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "vks-table-settings-group-body vks-table-settings-data-actions",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "convert-2-csv btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("export-csv")
                          },
                        },
                      },
                      [_vm._v(" Save as CSV ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "convert-2-csv btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("export-json")
                          },
                        },
                      },
                      [_vm._v(" Save as JSON ")]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }